import React from 'react';
import { SectionWrapper } from './SectionWrapper';
const chapters = [{
  num: 'Capítulo 1',
  title: 'La anatomía del caos',
  desc: 'Entiende exactamente qué ocurre en el cerebro de tu hijo durante un berrinche. Por qué no te escucha. Por qué no puede parar aunque quiera. Y cómo distinguir entre una crisis emocional real y una protesta orientada a conseguir algo.'
}, {
  num: 'Capítulo 2',
  title: 'El error de los primeros 30 segundos',
  desc: 'Descubre por qué los primeros segundos del berrinche deciden si la crisis dura 3 minutos o 3 horas. Aprende qué frases apagan el incendio y cuáles lo alimentan sin que te des cuenta.'
}, {
  num: 'Capítulo 3',
  title: 'El Método Espejo Rápido paso a paso',
  desc: 'Los 3 pasos exactos para intervenir en 180 segundos. Con scripts listos para usar, checklists de aplicación y señales para saber que el método está funcionando.',
  isCore: true
}, {
  num: 'Capítulo 4',
  title: 'Escenarios de alto riesgo',
  desc: 'El supermercado. La hora de dormir. El baño. Las salidas. Aprende a aplicar el protocolo en los lugares donde más temes que ocurra una crisis.'
}, {
  num: 'Capítulo 5',
  title: 'Blindaje diario',
  desc: 'Cómo hablar después de la tormenta. Cómo identificar las señales antes de que explote. Y cómo prevenir el 80% de los berrinches de la semana que viene.'
}, {
  num: 'FAQ',
  title: 'Las preguntas de las 11 PM',
  desc: 'Respuestas directas para las dudas que aparecen en el peor momento. Qué hacer si te pega. Qué pasa si explotas tú también. Qué ocurre si no funciona en 3 minutos.'
}];
export function WhatsInside() {
  return <SectionWrapper className="bg-cream py-20" constrained={false} data-id="element-349">
      <div className="max-w-5xl mx-auto px-6" data-id="element-350">
        <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center" data-id="element-351">
          Qué incluye el protocolo
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-352">
          {chapters.map((chapter, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-soft border-l-4 border-l-sky flex flex-col" data-id="element-353">
              {chapter.isCore && <div className="mb-4" data-id="element-354">
                  <span className="inline-block bg-yellow-100 text-yellow-800 font-sans text-xs font-bold px-3 py-1 rounded-full" data-id="element-355">
                    ⭐ EL NÚCLEO DEL MÉTODO
                  </span>
                </div>}

              <h3 className="font-sans text-2xl font-bold text-ink mb-2" data-id="element-356">
                {chapter.num}: {chapter.title}
              </h3>

              <p className="font-sans text-ink-mid leading-relaxed mb-6" data-id="element-357">
                {chapter.desc}
              </p>

              {chapter.isCore && <div className="mt-auto bg-sky-light/30 p-5 rounded-lg border border-sky-light" data-id="element-358">
                  <div className="space-y-3 font-sans text-sm font-medium text-ink" data-id="element-359">
                    <p data-id="element-360">
                      ⏱ PASO 1 <span className="text-sky font-bold" data-id="element-361">→</span>{' '}
                      Etiqueta la tormenta (0–60 seg)
                    </p>
                    <p data-id="element-362">
                      ⏱ PASO 2 <span className="text-sky font-bold" data-id="element-363">→</span>{' '}
                      Ancla con la voz (60–120 seg)
                    </p>
                    <p data-id="element-364">
                      ⏱ PASO 3 <span className="text-sky font-bold" data-id="element-365">→</span>{' '}
                      Cierra con presencia (120–180 seg)
                    </p>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}